import React, { useEffect, useRef } from 'react';
// import styled from 'styled-components';
import PropTypes from 'prop-types';
import { RadioStyle } from '@components/radio-button';
import { get } from 'lodash';

export function RadioForm({ name, text, validate, formState, value, register, setValue, checked }) {
  const validateRegister = {};
  const refCurrent = useRef(null);
  const { errors } = formState;
  if (validate.required) {
    validateRegister.required = 'Campo obligatorio';
  }
  useEffect(() => {
    register(name, validateRegister);
  }, [name]);
  const err = get(errors, name);
  useEffect(() => {
    if (err) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);
  return (
    <div ref={refCurrent}>
      <RadioStyle
        name={name}
        text={text}
        value={value}
        onChange={(e) => {
          setValue(name, e.target.value, { shouldValidate: true });
        }}
        checked={checked}
      />
    </div>
  );
}

RadioForm.propTypes = {
  // TODO:revisar caso de uso con el tipo number y value
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object,
  setValues: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
};

RadioForm.defaultProps = {
  formState: { errors: {} },
  setValues: () => {},
  name: '',
  value: ''
};
